export var MediaType;
(function (MediaType) {
    MediaType["Audio"] = "audio";
    MediaType["Image"] = "image";
    MediaType["Video"] = "video";
    MediaType["Unknown"] = "unknown";
    MediaType["Csv"] = "csv";
})(MediaType || (MediaType = {}));
